import {Component, Input, Optional} from '@angular/core';
import {CloseButtonData} from '@/controls/close-button/close-button-data';
import {MatDialogRef} from '@angular/material/dialog';
import {Log} from '@/_services/log.service';
import {GLOBALS, GlobalsService} from '@/_services/globals.service';
import {ColorCfgComponent} from '@/controls/color-cfg/color-cfg.component';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';

@Component({
  selector: 'app-close-button',
  templateUrl: './close-button.component.html',
  styleUrls: ['./close-button.component.scss'],
  imports: [
    ColorCfgComponent,
    MatIcon,
    MatIconButton
  ]
})
export class CloseButtonComponent {

  @Input()
  data: CloseButtonData = new CloseButtonData();

  constructor(public globals: GlobalsService,
              @Optional() public dialogRef: MatDialogRef<any>) {
  }

  get classForDebug(): string {
    return GLOBALS.isDebug ? 'debug' : '';
  }

  get showColorCfg(): boolean {
    return GLOBALS.editColors && this.data.colorKey != null;
  }

  get mayDebug(): boolean {
    return Log.mayDebug;
  }

  clickClose() {
    if (this.data.closeAction != null) {
      this.data.closeAction?.().subscribe(result => {
        if (result) {
          this.dialogRef?.close(this.data.dialogClose);
        }
      });
    } else {
      this.dialogRef?.close(this.data.dialogClose);
    }
  }
}
